import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-mips-review-actions-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="actions-container">
      <button id="openBtn" data-action="open">Open</button>
    </div>
  `,
  styles: [`
    .actions-container {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    #openBtn {
      cursor: pointer;
      border: none;
      border-radius: 4px;
      height: 26px;
      padding: 0 14px;
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 0.3px;
      line-height: 1;
      background-color: #0099ab;
      color: white;
    }
    #openBtn:hover {
      background-color: #007483;
    }
  `],
})
export class MipsReviewActionsRendererComponent implements ICellRendererAngularComp {
  agInit(_params: ICellRendererParams): void {}

  refresh(_params: ICellRendererParams): boolean {
    return true;
  }
}
